import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux';
import { store } from './store/store';
import Navigator from '../src/Routes/Navigator';
import 'swiper/css';
import 'swiper/css/autoplay';
function App() {
  return (
    <Router>
       <Provider store={store}>
        <Navigator/>        
    </Provider>
    </Router>
  );
}

export default App;
